// extracted by mini-css-extract-plugin
export default {"header":"header_header__96kzO","details":"header_details__Za48M"};